import { type ReactNode } from 'react'
import { type UseFormReturn, FormProvider } from 'react-hook-form'
import { HotelResultsFormState } from '@reward-platform/ancillaries-schemas/hotel'

type SearchFormProviderProps = {
  form: UseFormReturn<HotelResultsFormState>
  children: ReactNode
}

const SearchFormProvider = ({ form, children }: SearchFormProviderProps) => {
  // Form values are schema-validated and normalized before this boundary.
  return <FormProvider {...form}>{children}</FormProvider>
}

export default SearchFormProvider
